import withAuthentication from "../base/AuthComponent";
import DrawerAppBarHOC from "../home/DrawerAppBar";
import { TakeOrderComponentBody } from "./TakeOrderComponent";

function TakeOrderTableFridayComponent() {
  return (
    <DrawerAppBarHOC
      title="Prendi ordine di venerdì"
      content={<TakeOrderComponentBody isTakeAway={1} isFriday={1} />}
    />
  );
}
export default withAuthentication(TakeOrderTableFridayComponent);
